import ApiService from '@/core/services/api.service'
import { formatDBDate, getCurrentDate } from '@/utils/date'

const buildReportFilterParams = params => ({
  startDate: formatDBDate(params.startDate) || undefined,
  endDate: formatDBDate(params.endDate) || undefined,
  storeId: params.storeId || undefined,
  billType: params.billType || undefined,
  billNumber: params.billNumber || undefined,
  imeiCode: params.imeiCode || undefined,
  productId: params.productId || undefined,
  categoryIds:
    params.categoryIds && params.categoryIds.length
      ? params.categoryIds.join(',')
      : undefined,
  groupByImei: params.groupByImei || undefined,
})

const ProductImeiRevenueReportService = {
  /**
   * Fetch stores by user
   */
  async fetchStoresByUser() {
    const response = await ApiService.get('/stores/getStores')
    return response.data.data || []
  },

  async fetchCategoryTreeOptions() {
    const response = await ApiService.query('categories', {
      params: { page: 1, limit: 1000, name: '', code: '', allMerchant: true },
    })
    return response.data.data.list_caterogy || []
  },

  async searchProductsByName(name) {
    const q = name != null ? String(name).trim() : ''
    if (!q) return []
    const response = await ApiService.get(
      `products/searchProductByName?name=${encodeURIComponent(q)}`
    )
    return response.data.data || []
  },

  /**
   * Fetch product IMEI revenue report list
   */
  async fetchReportList(params) {
    const queryParams = {
      ...buildReportFilterParams(params),
      page: params.page || 1,
      limit: params.limit || 20,
    }

    const response = await ApiService.query('/v1/product-imei-revenue-reports', {
      params: queryParams,
    })
    return response.data.data
  },

  /**
   * Fetch summary aggregations
   */
  async fetchReportSummary(params) {
    const queryParams = buildReportFilterParams(params)

    const response = await ApiService.query('/v1/product-imei-revenue-reports/summary', {
      params: queryParams,
    })
    return response.data.data
  },

  async fetchSyncState() {
    const response = await ApiService.query('/v1/sync-states/latest', {
      params: { type: 'product_imei_revenue_report' },
    })
    return response.data.data
  },

  async syncData() {
    const response = await ApiService.post('/v1/product-imei-revenue-reports/sync')
    return response.data.data
  },

  async exportExcel(params) {
    const queryParams = buildReportFilterParams(params)

    const response = await ApiService.get('/v1/product-imei-revenue-reports/export', {
      params: queryParams,
      responseType: 'blob',
    })

    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute(
      'download',
      `bao_cao_lai_lo_imei_${getCurrentDate('YYYYMMDD_HHmmss')}.xlsx`
    )
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  },
}

export default ProductImeiRevenueReportService
